var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6241_855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.707275 1.70654V5.87788C0.707212 6.40817 0.917754 6.91678 1.29261 7.29188L8.99994 14.9999C9.18747 15.1873 9.44178 15.2927 9.70694 15.2927C9.97211 15.2927 10.2264 15.1873 10.4139 14.9999L14.9999 10.4132C15.1874 10.2257 15.2927 9.97137 15.2927 9.70621C15.2927 9.44105 15.1874 9.18674 14.9999 8.99921L7.29261 1.29188C6.91751 0.917022 6.4089 0.706479 5.87861 0.706543H1.70728C1.44206 0.706543 1.18771 0.8119 1.00017 0.999436C0.812632 1.18697 0.707275 1.44133 0.707275 1.70654V1.70654Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.20728 4.20654C3.20728 4.33786 3.23314 4.4679 3.2834 4.58923C3.33365 4.71055 3.40731 4.82079 3.50017 4.91365C3.59303 5.00651 3.70327 5.08017 3.82459 5.13042C3.94592 5.18068 4.07595 5.20654 4.20728 5.20654C4.3386 5.20654 4.46863 5.18068 4.58996 5.13042C4.71128 5.08017 4.82152 5.00651 4.91438 4.91365C5.00724 4.82079 5.0809 4.71055 5.13116 4.58923C5.18141 4.4679 5.20728 4.33786 5.20728 4.20654C5.20728 4.07522 5.18141 3.94519 5.13116 3.82386C5.0809 3.70253 5.00724 3.59229 4.91438 3.49944C4.82152 3.40658 4.71128 3.33292 4.58996 3.28266C4.46863 3.23241 4.3386 3.20654 4.20728 3.20654C4.07595 3.20654 3.94592 3.23241 3.82459 3.28266C3.70327 3.33292 3.59303 3.40658 3.50017 3.49944C3.40731 3.59229 3.33365 3.70253 3.2834 3.82386C3.23314 3.94519 3.20728 4.07522 3.20728 4.20654Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6241_855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.71f1ddbf.svg";
export { ForwardRef as ReactComponent };